<!-- 项目文件 -->
<template>
<div class="posre">
    <Header1 :img="bgImg"></Header1>
    <div class="w100p bgfff">
        <div class="  bgfff">
            <div class="pt30 pb20 w1200 mauto">
                <div class="textc mt20 mb20 ">
                    <p class="fs36 c333 disinblock posre">
                        <span class="border-bottom1">
                            关于我们
                        </span>
                    </p>
                </div>
                <div class="pt10 pb15 overflow">
                    <div class=" floatl disinblock w780 box aa">
                       
                    <!-- <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions">
                    </video-player> -->
                    <div>
                        <img src="../../public/img/fengmian.png" class="imgauto" alt="">
                    </div>

                       
                        <!-- <p class=" disinblock floatl pr6">
                            <img class="w100p h400" src="../../public/img/img100.png">
                        </p>
                        <p class=" disinblock floatl pl6 pr6">
                           <span class="disblock fs0 pb6">
                                <img class="w100p h195" src="../../public/img/img101.png">
                           </span>
                            <span class="disblock pt6 fs0">
                                <img class="w100p h195" src="../../public/img/img102.png">
                            </span>
                        </p> -->
                    </div>
                    <div class=" textl floatr w400  box bge8f h440 disinblock">
                        <div class=" pl30 pr30 pt20 pb20 disinblock">
                            <h2 class="c1f8 fs20 fbold pt20 pb20">公司简介</h2>
                            <p class="fs16 c666 lh30">
                                江苏车里车外信息技术有限公司成立于
                                2015年，是全国唯一将驾培行业理论教学
                                与线下培训全维度打通，并实现实际运用
                                生产与智能驾校解决方案的系统与服务提
                                供商。致力于将智能、便捷、高效的驾培
                                体验与服务带入每个学员、每个驾校、每
                                个组织，构建智能互联的驾培汽车世界。
                            </p>
                        </div>
                    </div>
                </div>
                
            </div>
                <div class="pt30 w1200 mauto pb15 posre  h520 bg104  overflow">
                    <div class="w55p floatl disinblock posre ">
                        <!-- <div class="posab zindex1 left0 top0">
                            <img class="w100p hauto" src="../../public/img/img104.png">
                        </div> -->
                        <div class="pl30 pr30 pt30 pb30  zindex999 posab left0 top0">
                            <h2 class="c45a fs30 fbold w60p">我们是智能驾校解决方案的 系统与服务提供商</h2>
                            <div class="fs16 c333 lh30 w90p pt50">
                                江苏车里车外信息技术有限公司专业打造的「e学e驾」智能驾培
                                系统在驾驶培训行业领域为客户提供通信网络、IT、 智能终端和云服
                                务等有竞争力、安全可信赖的产品、解决方案与服务，与生态伙伴开
                                放合作，持续为客户创造价值，释放驾校潜能，丰富学员需求,激发
                                行业创新。江苏车里车外坚持围绕客户需求持续创新,加大技术研究
                                与服务投入,厚积薄发，推动行业升级、进步。
                
                            </div>
                        </div>
                    </div>
                    <!-- <div class="w55p zindex999 posre floatr disinblock"> -->
                        <!-- <img class="w100p hauto" src="../../public/img/img105.png"> -->
                    <!-- </div> -->
                </div>
            <div class=" pt20 pb20 w100p bgf6 mb20">
               <div class="w1200 mauto"">
                    <div class="textc mt20 mb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                我们为驾培行业创造价值
                            </span>
                        </p>
                    </div>
                    <div class="w100p overflow pt10">
                        <ul class="disinblock w100p mauto textc">
                            <li class=" w30p textl disinblock box pl20 pr20 ml20 mt10   posre bgfff vertop minh330">
                                <div class="overflow pt15 pr15">
                                    <img class="w52 h47 floatr" src="../../public/img/img106.png">
                                </div>
                                <div>
                                    <p class="fs22 c000 fbold oblique  pb5 pt5">
                                        01
                                    </p>
                                    <p class="fs18 c45a fbold  pb5 pt5">
                                    为客户创造价值
                                    </p>
                                    <p  class="fs14 c666 lh30 pb5 pt10">
                                        e学e驾为驾培行业用户提供高效便捷的驾培
                                        管理系统, 为学员用户提供- -站式的应用服
                                        务,真正的帮助驾校合作伙伴降本增效,提
                                        升产能,让学员用户享受高品质、便捷的驾
                                        培驾考与增值服务体验。
                                    </p>
                                </div>
                            </li>
                            <li class=" w30p textl disinblock box pl20 pr20 ml20 mt10   posre bgfff vertop minh330">
                                <div class="overflow pt15 pr15">
                                    <img class="w55 h47 floatr" src="../../public/img/img107.png">
                                </div>
                                <div>
                                    <p class="fs22 c000 fbold oblique  pb5 pt5">
                                        02
                                    </p>
                                    <p class="fs18 cffb fbold  pb5 pt5">
                                        促进行业的转型
                                    </p>
                                    <p class="fs14 c666 lh30 pb5 pt10">
                                        e学e驾为驾培行业的参与者提供完整的经
                                        营、培训、营销解决方案,将行业传统单一
                                        的经营模式通过ICT、方式、融入LBS与数据
                                        云计算，实现驾校运营线上线下无缝对接
                                        提高产能与服务质量,完成升级转型。

                                    </p>
                                </div>
                            </li>
                            <li class=" w30p textl disinblock box pl20 pr20 ml20 mt10   posre bgfff vertop minh330">
                                <div class="overflow pt15 pr15">
                                    <img class="w54 h52 floatr" src="../../public/img/img108.png">
                                </div>
                                <div>
                                    <p class="fs22 c000 fbold oblique  pb5 pt5">
                                        03
                                    </p>
                                    <p class="fs18 ced4  fbold pb5 pt5">
                                        为客户创造价值
                                    </p>
                                    <p class="fs14 c666 lh30 pb5 pt10">
                                    e学e驾为驾校提供完整的服务供应链,整合
                                    社会行业资源，协助驾校挖掘产业价值,延
                                    伸产品链,开拓新的经营点,创造价值。
                                    </p>
                                </div>
                            </li>
                            <li class=" w30p textl disinblock box pl20 pr20 ml20 mt10   posre bgfff vertop minh330">
                                <div class="overflow pt15 pr15">
                                    <img class="w50 h50 floatr" src="../../public/img/img109.png">
                                </div>
                                <div>
                                    <p class="fs22 c000 fbold oblique  pb5 pt5">
                                        04
                                    </p>
                                    <p class="fs18 ced05 fbold  pb5 pt5">
                                        促动产业链良性发展
                                    </p>
                                    <p class="fs14 c666 lh30 pb5 pt10">
                                    e学e驾主张开放、合作、共赢，与客户、伙伴
                                    合作创新、扩大产业价值,形成健康良性的产
                                    业生态系统。通过协助驾培行业转型与提升行
                                    业产能,聚拢专项客户流量,为驾培后市场服
                                    务提供高品质的消费流量资源,推动产业生态
                                    系统的良性发展。

                                    </p>
                                </div>
                            </li>
                            <li class=" w30p textl disinblock box pl20 pr20 ml20 mt10   posre bgfff vertop minh330">
                                <div class="overflow pt15 pr15">
                                    <img class="w48 h48 floatr" src="../../public/img/img110.png">
                                </div>
                                <div>
                                    <p class="fs22 c000 fbold oblique  pb5 pt5">
                                        05
                                    </p>
                                    <p class="fs18 c16d pb5 pt5">
                                        保障行业稳定生产
                                    </p>
                                    <p class="fs14 c666 lh30 pb5 pt10">
                                    e学e驾产品的应用对驾培行业的可持续发展
                                    与稳定性起着积极推动的作用。2020年,新
                                    冠疫情后,因e学e驾系统的运用，可有效降
                                    低驾校培训聚集密度,减少因聚集传播的可
                                    能性，帮助合作驾校优先复工,快速恢复产
                                    能。

                                    </p>
                                </div>
                            </li>
                            
                        </ul>
                    </div>
               </div>
            </div>
                
            <div class="w1200 mauto pb20 pt20">
                <div class=" textc mt20 mb20">
                    <p class="fs36 c333 disinblock posre">
                        <span class="border-bottom1">
                            企业资质荣誉
                        </span>
                    </p>
                </div>
                <div class="w100p overflow pt20 posre minh480">
                        <div v-swiper:mySwiper="swiperOption" class="posab zindex999 w100p h100p left0 top0 zindex-1 zoom1 indexbg">
                            <div class="swiper-wrapper " style="height: 480px;">
   
                                <div class="swiper-slide">
                                    <img class="w100p h450" src="../../public/img/img260.png">
                                </div>
                                <div class="swiper-slide">
                                    <img class="w100p h450" src="../../public/img/img261.png">
                                </div>
                                <div class="swiper-slide">
                                    <img class="w100p h450" src="../../public/img/img262.png">
                                </div>
                                <div class="swiper-slide">
                                    <img class="w100p h450" src="../../public/img/img263.png">
                                </div>
                                <div class="swiper-slide">
                                    <img class="w100p h450" src="../../public/img/img264.png">
                                </div>
                                <div class="swiper-slide">
                                    <img class="w100p h450" src="../../public/img/img265.png">
                                </div>
                            </div>
                            <div class="swiper-pagination change" style="bottom: 0;"></div>
                        </div>
                       
                       
                </div>
            </div>
                     
        </div>
    </div>
    <Footer></Footer>
</div>
</template>

<script>
    import Header1 from '@/components/Header1'
    import Footer from '@/components/Footer'
    import {
        videoPlayer
    } from 'vue-video-player'
    import 'video.js/dist/video-js.css'
    export default {
        data() {
            return {
                bgImg: require('../../public/img/bgg.png'),

                swiperOption: {
                    loopedSlides: 3,
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    loop: true,
                    speed: 2000,
                    spaceBetween: 30,
                    autoplay: {
                        stopOnLastSlide: false,
                        delay: 2000
                    },
                    autoplay: 2000,
                    autoplayDisableOnInteraction: false,
                    pagination: '.swiper-pagination',
                },

                // playerOptions: {
                //     playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                //     autoplay: false, // 如果为true,浏览器准备好时开始回放。
                //     muted: false, // 默认情况下将会消除任何音频。
                //     loop: false, // 是否视频一结束就重新开始。
                //     preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                //     language: 'zh-CN',
                //     aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                //     fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                //     sources: [{
                //         type: "video/mp4",
                //         src: require('../../public/img/company.mp4') // url地址
                //     }],
                //     poster: require('../../public/img/fengmian.png'), // 封面地址
                //     notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                //     controlBar: {
                //         timeDivider: true, // 当前时间和持续时间的分隔符
                //         durationDisplay: true, // 显示持续时间
                //         remainingTimeDisplay: false, // 是否显示剩余时间功能
                //         fullscreenToggle: true // 是否显示全屏按钮
                //     }
                // }
            };
        },
        components: {
            Header1,
            Footer,
            videoPlayer
        },
        mounted() {},
        methods: {

        },
        created() {

        },
    }
</script>
<style scoped>
    .bgrg {
        background: rgba(0, 0, 0, 0.5);
    }
    
    .change /deep/ .swiper-pagination-bullet {
        width: 30px;
        height: 10px;
        border-radius: 10px;
    }
    
    .bg104 {
        background-image: url('../../public/img/img104.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .video-js .vjs-icon-placeholder {
        width: 100%;
        height: 100%;
        display: block;
    }
    
    .vjs-custom-skin>.video-js .vjs-poster {
        border-radius: 0px;
    }
    
    .video-js .vjs-slider {
        border-radius: 0;
    }
    
    .vjs-custom-skin>.video-js .vjs-play-progress,
    .vjs-custom-skin>.video-js .vjs-volume-level {
        border-radius: 0em;
    }
    
    .vjs-custom-skin {
        border-radius: 0px;
        overflow: hidden;
    }
</style>